import { useInfiniteQuery } from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const fetchSubStocks = async ({ pageParam = 1, queryKey }) => {
  const [, { categoryName, limit, sortBy, sortOrder, searchTerm , location ,stockStatus}] = queryKey;
  const response = await apiClient.post("/api/v1/stocks/getStockSubCategory", {
    categoryName,
    page: pageParam,
    limit,
    sortBy,
    sortOrder,
    searchTerm,
    location,
    stockStatus
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return {
    subCategories: response.data.subCategories,
    nextPage: response.data.pagination.page + 1,
    totalPages: response.data.pagination.totalPages,
    totalCount: response.data.totalCount,
    totalStyles: response.data.totalStyles,
  };
};

export const useSubStocks = ({ categoryName = "", limit = 10, sortBy = "alphabetical", sortOrder = "asc", searchTerm = "" ,location = [] , stockStatus = ""}) => {
  return useInfiniteQuery({
    queryKey: ["substocks", { categoryName, limit, sortBy, sortOrder, searchTerm ,location , stockStatus}],
    queryFn: ({ pageParam = 1 }) => fetchSubStocks({ pageParam, queryKey: ["substocks", { categoryName, limit, sortBy, sortOrder, searchTerm, location,stockStatus }] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    select: (data) => {
      return {
        ...data,
        pages: data?.pages?.map((page) => ({
          ...page,
          subCategories: page.subCategories.filter((subCate) => subCate?.count >= 1),
        })),
      };
    },
  });
};
